export default __webpack_public_path__ + "static/media/reward.5b7158ee.svg";